import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { FinanceiroBaixa } from 'src/app/model/financeiro/financeiroBaixa';

@Injectable({
  providedIn: 'root'
})
export class FinanceiroBaixaService extends GenericService<FinanceiroBaixa>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("financeirobaixa")
  }
}
